/*global ScrollMagic TweenMax Power0 */
import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

// import ScrollMagic from 'ScrollMagic'
// import 'animation.gsap'
// import 'scrollmagic/scrollmagic/minified/plugins/animation.gsap.min.js'
// import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap'

// import { TweenMax, Power0 } from 'gsap/all'
import ScrollMagic from 'ScrollMagic'
// import 'animation.gsap'
// import 'debug.addIndicators'

import Container from './Container'

const Background = styled.div`
  ${props =>
    props.background &&
    css`
      background: #f4f4f3;
    `}

  ${props =>
    props.theme.name === 'payback' &&
    css`
      border-radius: 20px;
    `}
`

const Box = styled.div`
  display: flex;

  @media (max-width: 860px) {
    flex-direction: column;
    padding: 0;
  }
`

const Media = styled.div`
  width: 50%;
  margin-top: -60px;
  /* margin-top: 0; */

  @media (min-width: 860px) {
    order: 1;
    opacity: 0;
    transition: all 0.8s ease;
    transform: ${props =>
      props.reverse ? 'translateX(200%)' : 'translateX(-200%)'};

    ${props =>
      props.inView &&
      css`
        transform: translateX(0);
        opacity: 1;
      `}
  }

  @media (max-width: 860px) {
    width: 100%;
    /* order: 1; */
    margin-top: -50px;
    max-width: 580px;
  }

  ${props =>
    props.yAlign &&
    css`
      margin-top: 0;
      padding-top: 0;
      display: flex;
      align-items: center;
      justify-content: center;

      > div {
        width: 100%;
      }

      @media (max-width: 860px) {
        margin-top: 50px;
      }
    `}
`

const Main = styled.div`
  width: 50%;
  padding: 70px 0 70px 70px;
  order: 2;

  ${props =>
    props.reverse &&
    css`
      order: 0;
      padding-right: 70px;
      padding-left: 0;
    `}

  @media (max-width: 860px) {
    order: 2;
    width: 100%;
    padding: 30px 0;
  }

  ${props =>
    props.theme.name === 'payback' &&
    !props.reverse &&
    css`
      padding-left: 140px;

      @media (max-width: 1120px) {
        padding-left: 70px;
      }

      @media (max-width: 860px) {
        padding-left: 0;
      }
    `}
`

class Content extends React.Component {
  state = {
    inView: false,
  }

  constructor(props) {
    super(props)

    this.triggerRef = React.createRef()
    this.mediaRef = React.createRef()
    this.controller = new ScrollMagic.Controller()
  }

  componentDidMount() {
    this.mediaQueryList = window.matchMedia('(max-width: 860px)')

    if (!this.mediaQueryList.matches) {
      this.setupParallax()
    }

    this.mediaQueryList.addListener(mediaQueryEvent => {
      if (mediaQueryEvent.matches) {
        this.destroyParallax()
      } else {
        this.setupParallax()
      }
    })
  }

  componentWillUnmount() {
    this.destroyParallax()
  }

  mediaQueryWatcher(e) {
    if (e.matches) {
      // console.log('DEBUG: MOBILE')
    } else {
      // console.log('DEBUG: DESKTOP')
    }
  }

  setupParallax() {
    const triggerRef = this.triggerRef.current
    const mediaRef = this.mediaRef.current

    new ScrollMagic.Scene({
      triggerElement: triggerRef,
      triggerHook: 1,
      duration: '130%',
    })
      .on('enter', event => {
        // console.log('DEBUG: enter: event:', event)
        if (
          event.scrollDirection === 'FORWARD' ||
          (event.state === 'DURING' && event.type === 'enter')
        ) {
          // console.log('DEBUG: enter: FORWARD')
          this.setState({
            inView: true,
          })
        } else {
          // console.log('DEBUG: enter: BACKWARD')
        }
      })
      .on('end', event => {
        // console.log('DEBUG: end: event:', event)
        if (event.scrollDirection === 'FORWARD') {
          // console.log('DEBUG: end: FORWARD')
          this.setState({
            inView: false,
          })
        } else {
          // console.log('DEBUG: end: BACKWARD')
        }
      })

      // .removeIndicators()
      // .addIndicators()
      .addTo(this.controller)
  }

  destroyParallax() {
    if (this.controller) {
      this.controller.destroy(true)
    }
  }

  render() {
    const {
      children,
      image,
      reverse,
      background,
      spacing,
      yAlign = false,
    } = this.props
    return (
      <Container wide={background} noPadding spacingSmall={spacing}>
        <Background background={background}>
          <Container>
            <Box reverse={reverse} ref={this.triggerRef}>
              <Media
                reverse={reverse}
                ref={this.mediaRef}
                inView={this.state.inView}
                yAlign={yAlign}>
                {image}
              </Media>
              <Main reverse={reverse}>{children}</Main>
            </Box>
          </Container>
        </Background>
      </Container>
    )
  }
}

Content.propTypes = {
  children: PropTypes.node,
  image: PropTypes.node,
  reverse: PropTypes.bool,
  background: PropTypes.bool,
  spacing: PropTypes.bool,
}

export default Content
